import React from 'react'
import { SvgIcon } from '../svg-icon'

const defaultProps = {
    viewBoxSize: 48
}

const SupervisedIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M22,12c0,5.52-4.48,10-10,10S2,17.52,2,12S6.48,2,12,2S22,6.48,22,12z M16,8c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2
            S17.1,8,16,8z M9.5,6C8.12,6,7,7.12,7,8.5S8.12,11,9.5,11S12,9.88,12,8.5S10.88,6,9.5,6z M16,13.5c-2.49,0-4.5,1.12-4.5,2.5v3.97
            C11.67,19.99,11.83,20,12,20c3.53,0,6.54-2.31,7.59-5.49C18.77,13.9,17.47,13.5,16,13.5z M4.48,14.71
            c0.89,2.47,2.95,4.37,5.52,5.03V15.5c0-0.89,0.71-1.69,1.84-2.23C11.13,13.1,10.34,13,9.5,13C7.16,13,5.19,13.72,4.48,14.71z`}
        />
    </SvgIcon>
)

SupervisedIcon.defaultProps = defaultProps

export { SupervisedIcon }
